import React from "react";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center bg-dark text-light flex-grow">
      <h1 className="text-6xl font-bold">404</h1>
      <h2 className="text-4xl mt-4">Page introuvable !</h2>
      <p className="text-lg mt-2">Désolé, cette page n'existe pas</p>
      <a href="/" className="underline mt-4 block text-orange hover:text-white transition">
        Revenir à l'accueil
      </a>
    </div>
  );
};

export default NotFound;
